import { render } from "./ProductDetailsDtf.vue?vue&type=template&id=3479c97c&scoped=true"
import script from "./ProductDetailsDtf.vue?vue&type=script&lang=js"
export * from "./ProductDetailsDtf.vue?vue&type=script&lang=js"

import "./ProductDetailsDtf.vue?vue&type=style&index=0&id=3479c97c&scoped=true&lang=scss"
import "./ProductDetailsDtf.vue?vue&type=style&index=1&id=3479c97c&lang=scss"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3479c97c"]])

export default __exports__